import * as offers from '../core/selectors/offers';
import { getSelectedVehicle as selectedVehicle } from '../core/selectors/vehicles';
riot.tag2('offers-container', '<div class="animated-spinner page-load-spinner"></div> <yield></yield>', '', 'class="offers-container {is-loaded: isloaded}"', function(opts) {

    const self = this;

    self.mixin('redux');
    self.subscribe(offers[self.opts.offerType]);
    self.subscribe(selectedVehicle);

    self.on('mount', () => {
      self.isloaded = true;
    });
});
